import { CantileverButton } from 'components/CantileverButton'
import { useKnowledgeDocumentDataContext } from 'features/knowledgeDocumentViewer/contexts/KnowledgeDocumentDataContext'
import { Printer } from 'lucide-react'
import { pdfjs } from 'react-pdf'

export function PrintDocumentButton() {
  const { documentSignedURL } = useKnowledgeDocumentDataContext()

  pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`

  function applyPrintStyles() {
    const style = document.createElement('style')
    style.id = 'dynamic-print-css'
    style.innerHTML = `
    @media print {
      /* Hide everything in the body */
      body > *:not(#print-container) {
        display: none !important;
      }
      
      #print-container {
        display: block !important;
        position: absolute;
        left: 0;
        top: 0;
      }

      canvas {
        display: block !important;
        width: 100% !important;
        page-break-after: always !important;
        page-break-inside: avoid !important;
      }
    }
  `
    document.head.appendChild(style)
  }

  function removePrintStyles() {
    const style = document.getElementById('dynamic-print-css')
    if (style) style.remove()
  }

  const handlePrint = async () => {
    // pdfData should be the Uint8Array or Blob of the PDF
    if (!documentSignedURL) return
    const loadingTask = pdfjs.getDocument(documentSignedURL.signed_url)
    const pdf = await loadingTask.promise
    applyPrintStyles()
    const printContainer = document.createElement('div')
    printContainer.id = 'print-container'
    document.body.appendChild(printContainer)
    try {
      for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i)
        const viewport = page.getViewport({ scale: 2 }) // High res for print

        const canvas = document.createElement('canvas')
        const context = canvas.getContext('2d')!
        canvas.height = viewport.height
        canvas.width = viewport.width

        await page.render({ canvasContext: context, viewport }).promise
        printContainer.appendChild(canvas)
      }

      window.print()
    } finally {
      setTimeout(() => {
        removePrintStyles()
        if (printContainer.parentNode) {
          document.body.removeChild(printContainer)
        }
      }, 500)
    }
    document.body.removeChild(printContainer)
  }

  return (
    <CantileverButton iconOnly title='Print Document' onClick={handlePrint}>
      <Printer size={18} strokeWidth={1.5} />
    </CantileverButton>
  )
}
